import type { OwaDate } from '../../../schema';
import { GlobalCalendarLocale } from '../../../intl/globalCalendarLocale';
import asDate from '../../../adapters/asDate';

export default function getIntlDateBase(
    date: OwaDate,
    locale: GlobalCalendarLocale,
    format: 'numeric' | '2-digit'
): string {
    const formatter = Intl.DateTimeFormat(locale.toString(), {
        // Need to add mapping from the OWA time zone to the IANA one.  For now, simply use either UTC or
        // the current browser time zone.
        // https://dev.azure.com/outlookweb/Outlook%20Web/_workitems/edit/141924
        timeZone: date.tz == 'UTC' ? date.tz : undefined,
        day: format,
    });

    return formatter.format(asDate(date));
}
